import { render } from "./MathMaterials.vue?vue&type=template&id=55c536f3"
import script from "./MathMaterials.vue?vue&type=script&lang=js"
export * from "./MathMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__